// extracted by mini-css-extract-plugin
module.exports = {"MenuMain__root":"ndlM","MenuMain__list":"Y73z","MenuMain__list_item":"_6jZq"};